// Passkeys (WebAuthn) — issue #132, built against cynque-api-server#1183.
// The contract is the api's `passkeys_request_handlers.py`; the design is
// `.claude/plans/passkey-migration.md` in cynque-api-server.

/**
 * A sign-in method a deployment offers (`GET /api/users/authentication/methods`).
 * A set, not "passkey or password", so a later `oidc` is one more member (D9).
 */
export type TAuthMethod = 'passkey' | 'password'

export const KNOWN_AUTH_METHODS: readonly TAuthMethod[] = [
  'passkey',
  'password',
]

/** One of the signed-in user's passkeys. The api never returns key material. */
export interface IPasskey {
  id: string
  label: string
  createdAt: string
  /** null until the passkey has been used to sign in. */
  lastUsedAt: string | null
  /** Synced to a cloud keychain (iCloud, Google), so it survives a lost device. */
  backedUp: boolean
  transports: string[]
}

/**
 * The `type` of every problem-details body a passkey route can answer with.
 * A refused passkey sign-in shares password login's 403 deliberately, so the
 * caller cannot tell an unknown passkey from a disabled user.
 */
export const PASSKEY_PROBLEM_TYPES = {
  invalidCredentials: 'user_authentication/invalid_credentials',
  registrationInvalid: 'passkey_registration/invalid',
  alreadyRegistered: 'passkey_registration/already_registered',
  notFound: 'passkey/not_found',
  lastSignInMethod: 'passkey/last_sign_in_method',
  signInBusy: 'passkey_authentication/busy',
} as const
